import { ResponseCatalog, RequestParams } from 'Models'
import { News, NewsStats } from 'Modules'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Id } from 'Src/types/aliases'
import { Callback } from 'Src/types/utilTypes'

type State = {
	news: ResponseCatalog<News>
	requestParams: RequestParams
	stats: NewsStats
}

const initialState: State = {
	news: new ResponseCatalog<News>(),
	requestParams: new RequestParams(),
	stats: new NewsStats(),
}

export namespace NewsNS {
	export type GetAll = PayloadAction<{ params: RequestParams; clear: boolean; callback?: Callback }>
	export type SetAll = PayloadAction<ResponseCatalog<News>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type CreateOne = PayloadAction<{ news: News; files?: File[] }>
	export type UpdateOne = PayloadAction<{ news: News; id: Id; files?: File[] }>
	export type ReadOne = PayloadAction<Id>
	export type SetOne = PayloadAction<News>
	export type DeleteOne = PayloadAction<Id>
	export type GetNewsAttach = PayloadAction<{ filename: string; newsId: Id }>
	export type SendNewsAttach = PayloadAction<{ file: File; newsId: Id }>
	export type DeleteNewsAttach = PayloadAction<{ fileId: Id; newsId: Id }>
	export type GetStats = PayloadAction
	export type SetStats = PayloadAction<NewsStats>
}

export const newsSlice = createSlice({
	name: 'news',
	initialState,
	reducers: {
		getAll: (state, action: NewsNS.GetAll) => {},
		setAll: (state, action: NewsNS.SetAll) => {
			state.news = action.payload
		},
		setRequestParams: (state, action: NewsNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		createOne: (state, action: NewsNS.CreateOne) => {},
		updateOne: (state, action: NewsNS.UpdateOne) => {},
		readOne: (state, action: NewsNS.ReadOne) => {},
		setOne: (state, action: NewsNS.SetOne) => {
			state.news.entries = state.news.entries.map((item) =>
				item.id === action.payload.id ? action.payload : item
			)
		},
		deleteOne: (state, action: NewsNS.DeleteOne) => {},
		getNewsAttach: (state, action: NewsNS.GetNewsAttach) => {},
		sendNewsAttach: (state, action: NewsNS.SendNewsAttach) => {},
		deleteNewsAttach: (state, action: NewsNS.DeleteNewsAttach) => {},
		getStats: (state, action: NewsNS.GetStats) => {},
		setStats: (state, action: NewsNS.SetStats) => {
			state.stats = action.payload
		},
	},
})
